// @flow

import type { HealthReportState } from "./types";

export const initialState: HealthReportState = {
  error: null,
  requestsInProgress: 0,
  workForceReport: [],
  carePlansReport: [],
  wellbeingAdviceReport: [],
  nurseAssessmentsReport: {
    content: [],
    pagination: {
      sort: { orders: [] },
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
    },
    totalElements: 0,
  },
};

export default initialState;
